import SalesSettingForm from './SalesSettingForm';

export default SalesSettingForm;
